<template>
  <d-list-group flush>
    <d-list-group-item class="p-0">
      <d-form @submit.prevent="submit()">
        <d-row>
          <d-col md="12">
            <d-card>
              <d-tabs card>
                <d-tab title="Tipos" active class="p-3">
                  <roles-form/>
                </d-tab>
                <d-tab title="Módulos" class="p-3">
                  <permissions-form/>
                </d-tab>
                <d-tab title="Usuários" class="p-3">
                  <users-form/>
                </d-tab>
              </d-tabs>
            </d-card>
          </d-col>
        </d-row>
      </d-form>
    </d-list-group-item>
  </d-list-group>
</template>

<script>
import RolesForm from '_modules/settings/components/AccessControl/RolesForm.vue';
import UsersForm from '_modules/settings/components/AccessControl/UsersForm.vue';
import PermissionsForm from '_modules/settings/components/AccessControl/PermissionsForm.vue';

export default {
  name: 'setting-profile',
  components: {
    RolesForm,
    UsersForm,
    PermissionsForm,
  },
  methods: {
  },
  mounted() {
    const { isAdmin } = this.$store.state.user;
    if (!isAdmin) {
      this.$router.push('/admin/overview');
    }
  },
};
</script>

<style lang="scss">
.tabs {
  .card-header { background: rgba(0, 0, 0, 0.03); }
}
</style>
